<!-- <div class="click" ngIf="result && !route" (click)="routeToProjectOnClick(result)">
<ng-container *ngTemplateOutlet="result"></ng-container>
</div>

<div class="click" *ngIf="!result && route" [routerLink]="route">
  <ng-container *ngTemplateOutlet="result"></ng-container>
</div> -->

<!-- <ng-template #result> -->
<div class="owner">
  <div class="owner-content">
    <ng-content select="[owner]"></ng-content>
  </div>
  @if (menu) {
    <mat-icon class="menu">more_vert</mat-icon>
  }
</div>

<div class="title">
  <ng-content select="[title]"></ng-content>
</div>

<div class="content">
  <div class="dynamic-content" #content>
    <ng-content></ng-content>
  </div>
</div>
<!-- </ng-template> -->
